import { Modal } from "@material-ui/core";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useStyle = makeThemedStyles("DelegateModal", (theme) => {
  return {
    modalBox: {
      position: "absolute",
      animation: "$flyin 1s ease forwards",
      maxWidth: "80vw",
      height: "auto",
      left: "-1080px",
      borderRadius: "15px",
      border: "none",
      fontSize: "14px",
      backgroundColor: "white",
      top: "200px",
      padding: "20px",
      margin: "auto 0",
      overflow: "hidden",
      "&:focus": {
        border: "none",
        outline: "none",
      },
    },
    "@keyframes flyin": {
      to: {
        left: "calc(50vw - 375px)",
      },
    },
  };
});

interface ModalProps {
  open: boolean;
  onClose?: VoidFunction;
}

const GenericModal = (props: React.PropsWithChildren<ModalProps>) => {
  const classes = useStyle();

  const onClose = () => {
    if (props.onClose) props.onClose();
  };
  return (
    <Modal open={props.open} onClose={onClose}>
      <div className={classes.modalBox}>{props.children}</div>
    </Modal>
  );
};

export default GenericModal;
